/**
 * Labstep
 *
 * @module grid/NewIndex/coldefs/resource/category
 * @desc Column Definition for resource category
 */

import type { ValueGetterParams } from 'ag-grid-community';
import { ICONS } from 'labstep-web/constants/icons';
import { useParamsStateContext } from 'labstep-web/contexts/params-state/hook';
import type { CellRendererParams } from 'labstep-web/core/DataGrid/types';
import { Link } from 'labstep-web/core/Link';
import type { Entity } from 'labstep-web/models/entity.model';

export const colDefResourceCategory = {
  colId: 'category',
  headerName: 'Category',
  headerComponentParams: {
    icon: ICONS.resource_template.primary,
    postFilterSettings: {
      path: 'template',
      field: 'name',
    },
  },
  editable: false,
  autoHeight: true,
  valueGetter: (params: ValueGetterParams): number | null => {
    return params.data?.template?.guid || null;
  },
  valueGetterExport: (params: ValueGetterParams) =>
    params.node?.data?.template?.name || '',
  cellRenderer: (params: CellRendererParams<Entity>) => {
    const { entityView } = useParamsStateContext();
    if (!entityView) {
      return null;
    }
    if (!params.data?.template) {
      return '';
    }
    return (
      <div>
        <Link
          to="resource_index"
          query={{
            template_id: params.data?.template.guid,
          }}
        >
          {params.data?.template.name}
        </Link>
      </div>
    );
  },
};
